/* eslint-disable react/no-deprecated */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import { faFileImage } from '@fortawesome/fontawesome-free-solid'
import ImageUploading from 'react-images-uploading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withStyles } from '@material-ui/core/styles'
import Cropper from 'react-easy-crop'
import Slider from '@material-ui/core/Slider'
import CloseIcon from '@material-ui/icons/Close'
import _ from 'lodash'
import AddIcon from '@material-ui/icons/Add'
import { BORDER_RADIUS, mainColor } from '../../constants/theme'
import Button from '../Button'
import IconButton from '../IconButton'
import { styles } from './DraggableImage.styles'
import { onChangePicture, onCropChange, onCropComplete, onZoomChange } from './DraggableImage.service'
import { maxSize, typeError } from '../../constants'

const INITIAL_STATE = {
  zoom: 1,
  minZoom: 0.5,
  picture: [],
  crop: { x: 0, y: 0 },
  initialCroppedAreaPixels: null,
  initialZoom: 1
};
class DraggableImage extends React.PureComponent {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    this.setState({
      picture: this.props.picture || []
    });
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.picture, this.props.picture)) {
      this.setState({
        picture: this.props.picture || []
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { loadingCropper, picture, disableLoader } = nextProps;
    const { loadingCropper: oldLoadingCropper, picture: oldPicture } = this.props;

    if ((!_.isEqual(loadingCropper, oldLoadingCropper) || !_.isEqual(picture, oldPicture)) && loadingCropper) {
      this.setState({
        ...INITIAL_STATE,
        picture: picture || []
      });

      if (loadingCropper) {
        disableLoader(false);
      }
    }
  }

  render() {
    const {
      classes,
      maxFileSize,
      handleRemove,
      multiple,
      defaultText,
      aspect,
      loadingCropper,
      isDesign,
      cropProps,
      cropStyle,
      restrictPosition = false,
      cropContainerClassName,
      hideRemoveButton = false,
    } = this.props;
    const { zoom, minZoom, crop, picture = [] } = this.state;
    return (
      <ImageUploading
        multiple={multiple}
        maxFileSize={maxFileSize}
        acceptType={['png', 'jpg', 'jpeg']}
        value={picture}
        onChange={image => onChangePicture(image, this)}
        dataURLKey='imageUrl'
      >
        {({ imageList = [], onImageUpload, onImageRemove, isDragging, errors = {}, dragProps }) => {
          return (
            <div
              className={`${classes.container} ${cropProps &&
                cropProps &&
                'col-md-12 col-sm-8 col-xs-12 col-lg-12 col-xl-12 '} `}
            >
              <div
                className={classes.droppable}
                {...dragProps}
                style={{
                  borderColor: isDragging ? mainColor.secondaryColor : mainColor.colorBlack,
                  borderWidth: isDragging ? 2 : 1,
                  ...cropProps
                }}
              >
                {imageList.length > 0 && imageList[0].imageUrl ? (
                  <div className={cropContainerClassName || (cropProps ? classes.cropContainer : classes.defaultCropContainer)}>
                    {!hideRemoveButton && (
                      <IconButton
                        aria-label='Delete'
                        className={classes.arroundIcon}
                        onClick={() => {
                          handleRemove();
                          onImageRemove();
                        }}
                      >
                        <CloseIcon className={classes.icon} />
                      </IconButton>
                    )}

                    {!loadingCropper && (
                      <Cropper
                        image={imageList[0].imageUrl}
                        crop={crop}
                        style={{
                          containerStyle: {
                            borderRadius: BORDER_RADIUS
                          }
                        }}
                        zoom={zoom}
                        restrictPosition={restrictPosition}
                        aspect={aspect}
                        minZoom={minZoom}
                        classes={{ mediaClassName: classes.image }}
                        onZoomChange={zoom => onZoomChange(zoom, this)}
                        onCropChange={crop => onCropChange(crop, this)}
                        onCropComplete={(_, croppedAreaPixels) => {
                          onCropComplete(_, croppedAreaPixels, this);
                        }}
                        onMediaLoaded={({ naturalWidth, naturalHeight }) =>
                          this.setState({
                            cropSize: { width: naturalWidth, height: naturalHeight }
                          })
                        }
                      />
                    )}
                  </div>
                ) : (
                  <div className={cropProps ? cropStyle : classes.defaultCrop}>
                    {!isDesign ? (
                      <>
                        <FontAwesomeIcon icon={faFileImage} className={classes.iconFile} />
                        <p
                          style={{
                            color: errors ? mainColor.colorRed : mainColor.colorBlack,
                            textAlign: 'center'
                          }}
                        >
                          {errors
                            ? errors.maxFileSize
                              ? maxSize
                              : errors.acceptType && typeError
                            : defaultText}
                        </p>
                        <Button onClick={onImageUpload} {...dragProps} className='my-2 py-1'>
                          Choisir une image
                        </Button>
                      </>
                    ) : (
                      <>
                        <AddIcon
                          onClick={() => {
                            onImageUpload();
                          }}
                          className={classes.addIcon}
                        />
                        <p
                          style={{
                            color: errors ? mainColor.colorRed : mainColor.colorBlack,
                            textAlign: 'center'
                          }}
                        >
                          {errors
                            ? errors.maxFileSize
                              ? maxSize
                              : errors.acceptType && typeError
                            : defaultText}
                        </p>
                      </>
                    )}
                  </div>
                )}
              </div>
              {imageList.length > 0 && imageList[0].imageUrl && !isDesign && (
                <div className={classes.controls}>
                  <p>Zoom</p>
                  <Slider
                    value={zoom}
                    style={{ color: mainColor.secondaryColor, marginLeft: 10 }}
                    min={minZoom}
                    key={0}
                    max={1.6}
                    step={0.1}
                    aria-labelledby='Zoom'
                    onChange={(e, zoom) => onZoomChange(zoom, this)}
                  />
                </div>
              )}
            </div>
          );
        }}
      </ImageUploading>
    );
  }
}
export default withStyles(styles)(DraggableImage);